import { render, staticRenderFns } from "./orgMainInfo.vue?vue&type=template&id=dd8412a8&scoped=true&"
import script from "./orgMainInfo.vue?vue&type=script&lang=js&"
export * from "./orgMainInfo.vue?vue&type=script&lang=js&"
import style0 from "./orgMainInfo.vue?vue&type=style&index=0&id=dd8412a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8412a8",
  null
  
)

export default component.exports